import React from "react";
import PropTypes from "prop-types";

import Button from "ui/Button";

import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';
import UndoIcon from "@mui/icons-material/Undo";
import GroupIcon from '@mui/icons-material/Group';
import PersonIcon from '@mui/icons-material/Person';

const SubmitButton = ({ 
  uuid, 
  redeemState, 
  orderAmount,
  checkInAll,
  allowCheckout, 
  onClick 
}) => {

  const buttonTypes = {
    checkIn: {
      label: "Check In",
      icon: CheckCircleOutlineIcon,
      action: () => onClick(uuid, false, "check_in")
    },
    checkOut: {
      label: "Check Out",
      icon: UndoIcon,
      action: () => onClick(uuid, false, "check_out")
    },
    checkInGroup: {
      label: `Check In ${orderAmount} Tickets`,
      icon: GroupIcon,
      action: () => onClick(uuid, false, "check_in", orderAmount)
    },
    checkInIndividual: {
      label: "Check In 1 Ticket",
      icon: PersonIcon,
      action: () => onClick(uuid, false, "check_in")
    },
    approve: {
      label: "Approve",
      icon: FactCheckOutlinedIcon,
      action: () => onClick(uuid, false, "approve")
    }
  };

  const getButtonConfig = () => {
    if (redeemState === "completed") {
      return allowCheckout ? buttonTypes.checkOut : buttonTypes.checkIn;
    }
    if (orderAmount > 1 && redeemState === "initiated") {
      return checkInAll ? buttonTypes.checkInGroup : buttonTypes.checkInIndividual;
    }
    if (redeemState === "initiated") return buttonTypes.checkIn;
    if (redeemState === "pending") return buttonTypes.approve;
  };

  const config = getButtonConfig();

  return (
    <Button
      highlighted
      icon={config.icon}
      onClick={config.action}
      fullwidth
      disabled={redeemState === "completed" && !allowCheckout}
    >
      {config.label}
    </Button>
  );
};

SubmitButton.propTypes = {
  uuid: PropTypes.string,
  redeemState: PropTypes.string,
  orderAmount: PropTypes.number,
  checkInAll: PropTypes.bool,
  allowCheckout: PropTypes.bool,
  onClick: PropTypes.func,
};

export default SubmitButton; 